
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getintegral, getSignlist, operateCredit, getRuleList } from '@/api/user.js'
import iconjf from '@/assets/ico-jd.png'
import icongz from '@/assets/ico-gz.png'
import iconqc from '@/assets/icon-qianc.png'
import icon1 from '@/assets/user-04.png'
import icon2 from '@/assets/user-05.png'
import icon3 from '@/assets/user-06.png'
import icon4 from '@/assets/user-07.png'
import config from '@/config'
import Storage from '@/storage'
import { getNowtDate } from '@/libs/utils.js'
export default {
name: 'sign',
components: {
Group,
Cell
},
data () {
return {
baseUrl: config.baseUrl,
iconjf: iconjf,
icongz: icongz,
tabOne: false,
iconqc: iconqc,
icon1: icon1,
icon2: icon2,
icon3: icon3,
icon4: icon4,
signres: 2,
integral: 0,
allnow: '',
date: getNowtDate(),
owner_type: config.owner_type,
rulelist: [],
userid: Storage.get('userid')
}
},
mounted () { },
created () {

this.getISsign()
this.getintegralTotal()
this.getRule()
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
gohome () {
this.$router.push({ name: 'mallIndex' })
},
getintegralTotal () {
/* 得到用户积分总信息 */
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue
})
},
getISsign () {
/* 获取签到记录 */
getSignlist({
accountid: this.accountid,
month: this.date.slice(0, 7)
}).then(res => {
let currentdate = getNowtDate()
if (res.returnValue && res.returnValue.length > 0) {
res.returnValue.forEach((item, index) => {
if (item.searchdate === currentdate) {
this.signres = item.signres
}
})
}
})
},
sign () {
/* 添加积分 */
operateCredit({
accountid: this.accountid,
rulecode: 'signin001',
owner_type: this.owner_type,
terminaltype: 2
}).then(res => {
this.$vux.toast.text('签到成功', 'middle')
this.date = this.date.slice(0, 7)
this.getintegralTotal()
this.getISsign()
this.getTrading()
this.getRule()
})
},
getRecord () {
this.$router.push({ path: '/userinfo/signlist' })
},
getRule () {
getRuleList({
incometype: 1,
owner_type: this.owner_type,
page: 1,
rows: 20,
userid: this.userid,
accountid: this.accountid
}).then(res => {
this.rulelist = res.returnValue.list
res.returnValue.list.forEach(item => {
this.addIntegral = this.addIntegral + item.cycgetcnt
})
})
},
complete (link) {
window.location.href = encodeURI(link)
}
}
}
